import { cloneDeep } from 'lodash';
import type { ITableLayer } from '@/version-types';
import { applyTableLayout, type TableLayoutOptions } from './table-layout';

/**
 * 通过统一的纯数据布局器修复外部解析或历史表格的尺寸数据。
 */
const fixTableLayout = async <T extends ITableLayer | ITableLayer<true>>({
    originalLayer,
    options = { mode: 'repair' },
}: {
    originalLayer: T;
    options?: TableLayoutOptions;
}): Promise<T> => {
    const newLayer = cloneDeep(originalLayer);
    return applyTableLayout(newLayer, options);
};

export default fixTableLayout;
